import React, { useState, useEffect } from 'react'

import { func } from 'prop-types'

let AdultModal

function LazyAdultContentModal({ setViewerIsAdult, hideAdultModal }) {
  const [isLoaded, setIsLoaded] = useState(!!AdultModal)

  useEffect(() => {
    if (AdultModal) return

    import('Pods/Shared/AdultContentModal').then((module) => {
      AdultModal = module.default
      setIsLoaded(true)
    })
  }, [])

  if (isLoaded && AdultModal) {
    return <AdultModal setViewerIsAdult={setViewerIsAdult} hideAdultModal={hideAdultModal} />
  }

  return null
}

LazyAdultContentModal.propTypes = {
  setViewerIsAdult: func.isRequired,
  hideAdultModal: func.isRequired,
}

export default LazyAdultContentModal
